<template>
  <div>
    <Button
      v-if="infoCtrl && isDetailLoad && editState"
      style=" margin-left:310px ; float: left; margin-top: -64px;"
      type="primary" @click="infoCtrl=false"
    >修改</Button>
    <Row v-if="!infoCtrl && isDetailLoad" class="case-form">
      <Form
        ref="formData" :model="formData"
        :rules="ruleValidate" :label-width="100"
      >
        <FormItem label="受理法院">
          <mySelect
            ref="courtSelect"
            v-autoFill="autoFill.court"
            :path="'/report/courts'"
            :placeholder="'请选择管辖法院'"
            :placeholder-input="'请输入管辖法院'"
            :default-obj="defaultCourt"
            :key-name="'name'"
            :is-load="false"
            @getValue="getCourtId"
          />
        </FormItem>
        <FormItem label="案号" prop="caseNumber">
          <Input
            v-model="formData.caseNumber" v-autoFill="autoFill.caseNumber"
            placeholder="请输入案号" @on-change="getValue($event,'caseNumber')"
          />
        </FormItem>
        <FormItem label="受理日期" prop="acceptDate">
          <DatePicker
            v-autoFill="autoFill.acceptDate"
            transfer
            type="date"
            placeholder="请选择受理日期"
            style="width:100%"
            format="yyyy-MM-dd"
            :value="formData.acceptDate"
            @on-change="getValue($event,'acceptDate')"
          />
        </FormItem>
        <FormItem label="举证期限" prop="timeArr">
          <DatePicker
            v-model="timeArr"
            transfer
            type="daterange"
            placeholder="请选择举证期限"
            style="width:100%"
            @on-change="getTime"
          />
        </FormItem>
        <FormItem label="受理费用" prop="fees">
          <my-input
            append-text="￥"
            :default-data="formData.fees"
            :to-fixed="2"
            @getValue="getValue($event,'fees')"
          />
        </FormItem>
        <FormItem
          label="受理通知" prop="acceptedAttachments"
          :rules="[{ required: true,type:'array', message: '受理通知不能为空', trigger: 'blur' }]"
        >
          <file-upload
            :default-list="acceptedDefaultList || []"
            :upload-config="{}"
            @getFileList="getAttachmentList($event,'acceptedAttachments')"
          />
        </FormItem>
        <FormItem label="缴费票据" prop="payAttachments">
          <file-upload
            :default-list="payDefaultList || []"
            :upload-config="{}"
            @getFileList="getAttachmentList($event,'payAttachments')"
          />
        </FormItem>
      </Form>
      <Row class="detail-btn-box">
        <Button
          type="primary" style="margin-right:10px;"
          :disabled="isSubmit" @click="submitNew"
        >保存</Button>
        <Button v-if="defaultData" @click="infoCtrl=true">取消</Button>
      </Row>
    </Row>

    <Row v-if="infoCtrl&&isDetailLoad" class="detail-content">
      <Row><Col span="5" class="left-label">受理法院：</Col><Col span="16" class="right-content">{{ defaultData.court || "" }}</Col></Row>
      <Row><Col span="5" class="left-label">案号：</Col><Col span="16" class="right-content">{{ defaultData.caseNumber || "" }}</Col></Row>
      <Row><Col span="5" class="left-label">受理日期：</Col><Col span="16" class="right-content">{{ defaultData.acceptDate || "" }}</Col></Row>
      <Row><Col span="5" class="left-label">举证期限：</Col><Col span="16" class="right-content">{{ defaultData.proofStartTime || "" }} 至 {{ defaultData.proofEndTime || "" }}</Col></Row>
      <Row><Col span="5" class="left-label">受理费用：</Col><Col span="16" class="right-content">{{ common.formateNumber(defaultData.fees || "") }}</Col></Row>
      <Row>
        <Col span="5" class="left-label">受理通知：</Col>
        <Col span="16" class="right-content">
          <file-upload
            :default-list="acceptedDefaultList || []"
            :upload-config="{readOnly:true}"
          />
        </Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">缴费票据：</Col>
        <Col span="16" class="right-content">
          <file-upload
            :default-list="payDefaultList || []"
            :upload-config="{readOnly:true}"
          />
        </Col>
      </Row>
    </Row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import getQccKeyData from '@/libs/qcc.js'

export default {
  components: {},
  props: ['caseId', 'processId', 'editState'],
  data () {
    const overMillion = (rule, value, callback) => {
      if (Number(value) > 100000000) {
        return callback(new Error('金额不能超过一亿'))
      }
      callback()
    }
    return {
      isSubmit: false,
      infoCtrl: false,
      isDetailLoad: false,
      defaultData: '',
      acceptedDefaultList: [],
      payDefaultList: [],
      timeArr: [],
      formData: {
        court: '',
        courtId: '',
        caseNumber: '',
        acceptDate: '',
        proofStartTime: '',
        proofEndTime: '',
        fees: '',
        acceptedAttachments: [],
        payAttachments: []
      },
      ruleValidate: {
        caseNumber: [{ required: true, message: '案号不能为空', trigger: 'blur' }, { max: 32, message: '不能超过32个字符', trigger: 'blur' }],
        acceptDate: [{ required: true, message: '受理日期不能为空', trigger: 'blur' }],
        fees: [{ required: true, message: '受理费用不能为空', trigger: 'blur' }, { validator: overMillion, trigger: 'blur' }],
        acceptedAttachments: [{ require: true, type: 'array', message: '文件不能为空', trigger: 'change' }]
      },
      hasDetail: false,
      autoFill: {
        acceptDate: false,
        caseNumber: false,
        court: false
      },
      defaultCourt: {
        name: '',
        id: null
      }
    }
  },
  computed: {
    ...mapGetters(['qccData']),
    qccWatch() {
      return {
        isDetailLoad: this.isDetailLoad,
        hasData: !!this.qccData.length
      }
    }
  },
  watch: {
    qccWatch: {
      handler: async function(value) {
        if (value.isDetailLoad && value.hasData && !this.hasDetail && !this.infoCtrl) {
          this.formData.acceptDate = await getQccKeyData(this.qccData, 'acceptDate')
          this.autoFill.acceptDate = !!this.formData.acceptDate
          this.formData.caseNumber = await getQccKeyData(this.qccData, 'caseNumber')
          this.autoFill.caseNumber = !!this.formData.caseNumber
        }
      },
      deep: true
    }

  },
  created() {},
  beforeMount() {
    this.getCourt()
    this.getDetail()
  },
  mounted() {},
  updated() {},
  methods: {
    getCourtId(data) {
      this.formData.court = data.name
      this.formData.courtId = data.id
      if (this.autoFill.court) {
        this.autoFill.court = false
      }
    },
    // 获取受理详情
    getDetail() {
      const url = '/business/case-filing-accepted?processId=' + this.processId
      this.$get(url).then(res => {
        if (res.code == 0 && res.data) {
          this.defaultData = res.data
          this.infoCtrl = true
          this.giveDefaultData()
          this.hasDetail = true
        } else {
          this.defaultData = ''
          this.infoCtrl = false
          this.isDetailLoad = true
          this.hasDetail = false
        }
      })
    },
    // 获取受理法院
    getCourt() {
      const url = '/business/case/court/lawyer?caseId=' + this.caseId
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.formData.court = res.data
          // 接口没有返回id，只进行名称的回填
          this.defaultCourt = {
            name: res.data,
            id: ''
          }
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getValue(value, key) {
      if (key === 'caseNumber') {
        this.autoFill[key] = false
        return
      }
      this.formData[key] = value
      if (this.autoFill[key]) { this.autoFill[key] = false }
    },
    getTime(arr) {
      this.formData.proofStartTime = arr[0]
      this.formData.proofEndTime = arr[1]
    },
    // 获取图片列表
    getAttachmentList (arr, key) {
      this.formData[key] = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formData[key].push(obj)
        // if(this.formData[key].length > 0){
        //   this.$refs.formData.clearValidate('key')
        // }
      })
    },
    submitNew() {
      let url = '/business/case-filing-accepted'
      const ajaxData = {
        processId: this.processId,
        caseId: this.caseId
      }
      Object.assign(ajaxData, this.formData)
      if (this.defaultData) {
        url += `/${this.defaultData.id}`
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$patch(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      } else {
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      }
    },
    giveDefaultData() {
      this.formData.caseNumber = this.defaultData.caseNumber
      this.formData.acceptDate = this.defaultData.acceptDate
      this.formData.proofStartTime = this.defaultData.proofStartTime
      this.formData.proofEndTime = this.defaultData.proofEndTime
      this.timeArr = [this.defaultData.proofStartTime, this.defaultData.proofEndTime]
      this.formData.fees = this.defaultData.fees
      this.formData.acceptedAttachments = this.defaultData.acceptedAttachments
      this.acceptedDefaultList = this.defaultData.acceptedAttachments
      this.formData.payAttachments = this.defaultData.payAttachments
      this.payDefaultList = this.defaultData.payAttachments
      this.$set(this.formData, 'court', this.defaultData.court) // 这里不知道为什么，用this.formData.court = this.defaultData.court无效
      this.isDetailLoad = true
      if (this.defaultData.court) {
        this.defaultCourt = {
          name: this.defaultData.court,
          id: this.defaultData.courtId
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "../caseCommon.scss";
.add-btn{
    margin-top:-64px;
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/prosecute/acceptance.vue